import React, { useEffect, useState } from "react";
import { Dropdown, Menu, Modal, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { openConfirmNotification } from "../utils/toast";
import ProfileIcon from "../../assets/images/vectors/ProfileIcon";
import SetupIcon from "../../assets/images/vectors/SetupIcon";
import { ProfileForm } from "./ProfileForm";
import { roleSidebarMenu } from "./PrivateRoute";
import { CompanyForm } from "./CompanyForm";
import EngageServerLogin from "./EngageServer/EngageServerLogin";
import { getEnageUser } from "../hooks/getUserRole";
import { ManageCardsModal } from "./ManageCardsModal";

export const User = () => {
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const engageUserData = getEnageUser();
  const [formattedDateTime, setFormattedDateTime] = useState("");
  const [isModalOpen, setIsModalOpen] = useState();
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState();
  const [isEngageServerModalOpen, setIsEngageServerModalOpen] = useState(false);
  const [showCardModal, setShowCardModal] = useState(false);

  const handleMenuClick = (e) => {
    if (e.key === "profile") {
      setIsModalOpen(true);
      // navigate("/profile");
    } else if (e.key === "company") {
      setIsCompanyModalOpen(true);
    } else if (e.key === "logout") {
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("engageData");
      localStorage.removeItem("engageSiteData");
      openConfirmNotification("Success");
      navigate("/");
    } else if (e.key === "card") {
      setShowCardModal(true);
    } else if (e.key === "EngageServer") {
      if (
        engageUserData &&
        engageUserData?.username &&
        engageUserData?.password
      ) {
        navigate("/engagesitelist");
      } else {
        setIsEngageServerModalOpen(true);
      }
    }
  };

  const menu = (
    <Menu
      onClick={handleMenuClick}
      className=" bg-white !opacity-1 rounded-sm border-2 border-gray-200  !py-4 !px-3 "
    >
      <div className="flex items-center gap-2 px-4 py-1 w-fit max-w-[180px]">
        <ProfileIcon className="h-[32px] p-1 w-[32px] bg-customColor_10 rounded-full shrink-0" />
        <h4 className="font-medium font-['Poppins'] text-black text-[14px] leading-snug m-0 text-left break-words">
          {userData?.role_name}
        </h4>
      </div>

      {userData?.role_name !== "Customer" && (
        <Menu.Item key="profile" className=" !pl-[57px] !pt-[3px] profile ">
          Profile
        </Menu.Item>
      )}
      {[7, 8].includes(userData?.role_value) && (
        <Menu.Item key="card" className=" !pl-[57px] !pt-[3px] profile ">
          Payment Method
        </Menu.Item>
      )}
      {[7, 8].includes(userData?.role_value) && (
        <Menu.Item key="company" className=" !pl-[57px] !pt-[3px] profile ">
          Company
        </Menu.Item>
      )}
      {[4, 5, 7, 8].includes(userData?.role_value) && (
        <Menu.Item key="EngageServer" className="!pl-[57px] !pt-[3px] profile ">
          Engage Server
        </Menu.Item>
      )}
      {/* <Menu.Item key="Info" icon={<CreditCardOutlined />}>
        Card Info
      </Menu.Item> */}
      <Menu.Item key="logout" className=" !pl-[57px] profile">
        Logout
      </Menu.Item>
    </Menu>
  );

  const setupMenuItems =
    roleSidebarMenu[userData?.role_value]?.filter((item) =>
      [
        "/device-production",
        "/virtual-qr-production",
        "/on-site-register",
        "/hardware",
        "/license",
        "/licensecode",
        "/group",
        "/oeminfo",
        "/proxyserver",
        "/call-history",
      ].includes(item.key),
    ) || [];

  const setupMenu = (
    <Menu
      onClick={handleMenuClick}
      className=" bg-white !opacity-1 rounded-sm border-2 border-gray-200  !py-4 !px-3 "
    >
      {setupMenuItems?.map((item) => (
        <Menu.Item key={item.key} className="!pt-[4px] profile">
          <Link key={item.key} to={item.key}>
            {item.label}
          </Link>
        </Menu.Item>
      ))}
    </Menu>
  );

  //For time formatting
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();

      // Format the date as YYYY-MM-DD
      const formattedDate = now.toISOString().split("T")[0];

      // Format the time as HH:mm
      const formattedTime = now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false, // Use 24-hour format
      });

      setFormattedDateTime(`${formattedDate} ${formattedTime}`);
    }, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex justify-center items-center">
      <div className="mr-4 ">
        <p className="text-[#000000] font-[Poppins] text-[14px]">
          {formattedDateTime}
        </p>
      </div>
      <div className="flex gap-4">
        {setupMenuItems?.length ? (
          <Dropdown
            overlay={setupMenu}
            trigger={["click"]}
            className="h-[32px] w-[32px] customColor_10 "
          >
            <Tooltip title="Setup">
              <span className="flex items-center justify-center cursor-pointer bg-customColor_10 w-8 h-8 rounded-full">
                <SetupIcon className="h-[24px] w-[24px]" />
              </span>
            </Tooltip>
          </Dropdown>
        ) : (
          <></>
        )}
        <Dropdown
          overlay={menu}
          trigger={["click"]}
          className="h-[32px] w-[32px] customColor_10 "
        >
          <Tooltip title="Profile">
            <span className="flex items-center justify-center cursor-pointer bg-customColor_10 w-8 h-8 rounded-full">
              <ProfileIcon className="h-[24px] w-[24px]" />
            </span>
          </Tooltip>
        </Dropdown>
      </div>
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        // className="my-modal"
        closeIcon={false}
        footer={null}
        width={520}
        centered
        motion={false}
        destroyOnClose={true}
      >
        <ProfileForm setIsModalOpen={setIsModalOpen} />
      </Modal>
      <Modal
        open={isCompanyModalOpen}
        onCancel={() => setIsCompanyModalOpen(false)}
        closeIcon={false}
        footer={null}
        width={520}
        centered
        motion={false}
        destroyOnClose
      >
        <CompanyForm setIsModalOpen={setIsCompanyModalOpen} />
      </Modal>
      <Modal
        open={isEngageServerModalOpen}
        onCancel={() => setIsEngageServerModalOpen(false)}
        closeIcon={false}
        footer={null}
        width={520}
        centered
        motion={false}
      >
        <EngageServerLogin
          setIsEngageServerModalOpen={setIsEngageServerModalOpen}
        />
      </Modal>
      <Modal
        open={showCardModal}
        onCancel={() => setShowCardModal(false)}
        closeIcon={false}
        footer={null}
        width={520}
        centered
        motion={false}
        destroyOnClose
      >
        <ManageCardsModal setIsModalOpen={setShowCardModal} />
      </Modal>
    </div>
  );
};
